import styled, { css } from 'styled-components';

import FrontShopLink from 'ggApp/shared/containers/FrontshopLink';
import LanguageSelector from 'ggApp/shared/components/DropDownSelectors/Language';
import StoreSelector from 'ggApp/shared/components/DropDownSelectors/Store';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.Background};
    padding-top: 16px;
    > * {
        &:last-child {
            margin-bottom: 320px;
        }
    }
`;

const ActionStyles = css`
    position: relative;
    min-height: 48px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.Foreground};
    padding: 0 16px;
    &:hover,
    &:active,
    &:focus {
        color: ${({ theme }) => theme.colors.Foreground};
        background: rgba(102, 102, 102, 0.1);
    }
`;

const Button = styled.button`
   ${ActionStyles}
`

const Link = styled(FrontShopLink)`
   ${ActionStyles}
`;

const Languages = styled(LanguageSelector)`
    padding: 0 16px;
    justify-content: flex-start;
    li {
      justify-content: flex-start;
      padding: 0 16px;
    }
`;

const Stores = styled(StoreSelector)`
    padding: 0 16px;
    justify-content: flex-start;
    li {
      justify-content: flex-start;
      padding: 0 16px;
    }
`;

export {
    Wrap,
    Link,
    Languages,
    Stores,
    Button
};
